import React, {Component} from 'react';
import {showSnackbar} from "../../Redux/actions/snackbar";
import {hideLoadingBar, showLoadingBar} from "../../Redux/actions/loading";
import {connect} from "react-redux";
import {PGService} from "../../Remote/PowerGym";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import dayjs from 'dayjs';
import MyDialog from "../Common/MyDialog";
import {Formatters} from "../../Utils/Formatters";
import './ListTimetables.css';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import {withNamespaces} from 'react-i18next';


class ListTimetables extends Component {

    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);

        this.state = {
            timetables: null,
            dayjs: dayjs(),
            schedule_id: props.match.params.schedule_id,
            modal: {
                showModal: false,
                title: '',
                message: '',
                timetable_id: null,
                date: null
            },
        }
    }

    /**
     *
     */
    handleAgree = () => {
        this.props.showLoadingBar();

        PGService.book(this.state.modal).then(response => {

            this.props.hideLoadingBar();

            this.props.showSnackbar(response.message);

            if (response.code !== 200) {
                return
            }

            this.setState(prev => ({
                timetables: prev.timetables.map(t => {
                    if (t.id === this.state.modal.timetable_id) {
                        t['enrolled'] = true
                    }
                    return t
                })
            }))

        }).catch((e) => {
            console.warn(e);
        });

        this.handleClose();
    };

    /**
     *
     */
    handleClose = () => {
        this.setState((prev) => ({
            modal: {
                ...prev.modal,
                showModal: false,
            }
        }));
    };

    /**
     *
     * @param e
     */
    handleClick = (e) => {
        this.setState({
            modal: {
                showModal: true,
                title: this.props.t("Confirm enroll"),
                message: `Clase de ${e.name} de ${Formatters.formatTime(e.start_at)} a ${Formatters.formatTime(e.end_at)}`,
                timetable_id: e.id,
                date: this.state.dayjs.format("YYYY-MM-DD")
            }
        });
    };


    /**
     *
     */
    componentDidMount() {
        this.loadTimetables();
    }

    /**
     *
     * @param date
     */
    loadTimetables = (date) => {

        if (!date) {
            date = dayjs();
        }

        this.props.showLoadingBar();

        PGService.getTimetables(this.state.schedule_id, date.format("YYYY-MM-DD")).then(response => {
            this.setState({
                timetables: response.data.timetables,
                dayjs: date
            });
            this.props.hideLoadingBar();
        }).catch(error => {
            this.props.showSnackbar("No podemos mostrar los turnos para esta fecha");
            this.props.hideLoadingBar();
        });

    };

    /**
     *
     * @param offset
     */
    handleChangeDate = (offset) => {

        if (!offset) {
            this.loadTimetables();
            return;
        }

        this.loadTimetables(this.state.dayjs.add(offset, 'day'));
    };

    /**
     *
     * @returns {*}
     */
    render() {
        const {t} = this.props;

        return (
            <div>
                <h2>{t("Timetables on")} {Formatters.formatDate(this.state.dayjs, "dddd DD/MM")}</h2>

                <Grid container spacing={16}>
                    <Grid item xs>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.handleChangeDate(-1)}
                            disabled={this.state.dayjs.format("YYYY-MM-DD") === dayjs().format('YYYY-MM-DD')} 
                            className="changeBtn"
                        >
                            {t("Previous")}
                        </Button>
                    </Grid>

                    <Grid item xs>
                        <Button variant="contained" color="primary" onClick={() => this.handleChangeDate()} className="changeBtn">
                            {t("Today")}
                        </Button>
                    </Grid>

                    <Grid item xs>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.handleChangeDate(1)} className="changeBtn"
                            disabled={this.state.dayjs.format("YYYY-MM-DD") === dayjs().add(6, 'day').format('YYYY-MM-DD')}
                        >
                            {t("Next")}
                        </Button>
                    </Grid>
                </Grid>


                <List>
                    {
                        this.state.timetables && this.state.timetables.map((e) => {
                            return (
                                <ListItem
                                    onClick={! e.enrolled ? () => this.handleClick(e): null}
                                    key={e.id}
                                    className={e.enrolled ? "enrolled" : "" + e.users_count >= e.limit_count ? " full" : ""}
                                    button>
                                    <ListItemIcon>
                                        <Avatar>{e.name.charAt(0).toUpperCase()}</Avatar>
                                    </ListItemIcon>
                                    <ListItemText
                                            primary={`${e.name} de ${Formatters.formatTime(e.start_at)} a ${Formatters.formatTime(e.end_at)}`}
                                        secondary={`${t("Users enrolled")}: ${e.users_count} - ${t("Users limit")}: ${e.limit_count}`}
                                    />
                                </ListItem>
                            );

                        })
                    }

                    {
                        this.state.timetables === null ? t("Loading") : ""
                    }

                    {
                        this.state.timetables && this.state.timetables.length === 0 ? t("No Timetables") : ""
                    }

                </List>
                <MyDialog
                    {...this.state.modal}
                    handleClose={this.handleClose}
                    handleAgree={this.handleAgree}
                />
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    loading: state.loading
});

const mapDispatchToProps = dispatch => ({
    showLoadingBar: () => dispatch(showLoadingBar()),
    hideLoadingBar: () => dispatch(hideLoadingBar()),
    showSnackbar: (message) => dispatch(showSnackbar(message))
});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ListTimetables));
